import type { OrgFeature } from '@risksmart-app/modules/src/index';
import { createContext } from 'react';

/**
 * Seeded feature flags for an organisation marked `Meta.isE2eTestOrg`.
 * `null` means the live OpenFeature provider remains authoritative.
 */
export const E2eFlagOverridesContext = createContext<OrgFeature[] | null>(null);
